/* tslint:disable */

/**
 */
export class CheckControlView {
    definition?: boolean;
    production?: boolean;
    mesh?: boolean;
    packing?: boolean;
    equipment?: boolean;
    pipeenable?: boolean;
    pipeline?: boolean;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/check-control-view.ts